import { useState, createContext, useEffect } from "react";
export const ClientContext = createContext();
export const ClientProvider = ({ children }) => {
  const [paymentGateway, setPaymentGateway] = useState(false);
  const [dashboardData, setDashboardData] = useState(true);
  const [loadingTransaction, setLoadingTransaction] = useState(false);
  const [paymentType, setPaymentType] = useState("all");
  const [singleRoleData, setSingleRoleData] = useState([]);
  const [SettlementAPISttus, setSettlementAPISttus] = useState("none");
  const [isOpenSettlementAPISttus, setisOpenSettlementAPISttus] = useState(false);
  const [filter, setFilter] = useState({
    status: "all",
    client: [],
    dates: null,
    date_range: null,
    payment_status: [],
    gateway: [],
    users : ""
  });

  const [activeTab, setActiveTab] = useState("single");
  const [settlementActiveTab, setSettlementActiveTab] = useState("card");

  return (
    <ClientContext.Provider
      value={{
        paymentGateway,
        setPaymentGateway,
        dashboardData,
        setDashboardData,
        paymentType,
        setPaymentType,
        singleRoleData,
        setSingleRoleData,
        filter,
        setFilter,
        SettlementAPISttus,
        setSettlementAPISttus,
        setisOpenSettlementAPISttus,
        isOpenSettlementAPISttus,
        activeTab, 
        setActiveTab,
        loadingTransaction,
        setLoadingTransaction,
        setSettlementActiveTab,
        settlementActiveTab
      }}
    >
      {children}
    </ClientContext.Provider>
  );
};
